<template>
  <b-container>
  <h1 class="text-center pt-4 pb-4">{{ $t("action.addUser") }}</h1>
  <b-form @submit="onSubmit">

      <b-row class="mt-2">
        <b-col sm class="mt-4">
          <b-form-select v-model="form.user" :options="users" multiple :select-size="8"></b-form-select>  
          <div class="text-danger" v-if="!$v.form.user.required && $v.form.user.$dirty">{{ $t("info.required") }}</div>
        </b-col>         
      </b-row>
    
    <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("action.submit") }}</b-button>
    
  </b-form>

  <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
  </div>

  <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
  </div>

</b-container>
</template>

<script>
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';

import { globalF } from '../Helpers';

export default {
mixins: [globalF],
  data() {
    return {
      form: {
        user: []          
      },
      error: "",
      disabled: false,
      spinner: false
    }
  },
validations() {
      return {
        form: {
          user: {
            required
          }
        }
      }
},
mounted () {

},
computed: {
 users: function () {
    let usersList = this.$store.getters.getUserList;  
    let userBuilding = this.$store.getters.getUsersBuilding;
    let build = this.$store.getters.getBuildingToEdit;
    let res = [];
    let users = usersList;//usersList.filter(u => u.role === 1);

    if (users && userBuilding && build) {
      
      users.sort(function (a,b) {
        if(a.fname < b.fname) { return -1; }
        if(a.fname > b.fname) { return 1; }
        return 0;
      });

            for (let i = 0; i < users.length; i++) {
                let find = userBuilding.findIndex(u => u.IdUser === users[i].Id && u.IdBuilding === build.Id);
                if (find === -1) {
                    let options = {};
                    options.value = users[i];
                    options.text = users[i].fname.concat(" "+users[i].lname);
                    res.push(options);
                } 
            }
        }
        
    return res;
},
  url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  }
 },
methods:{    
    onSubmit(evt) {
      evt.preventDefault();
      this.emailexist = false;
      this.error = "";
      this.$v.$touch();
        if (!this.$v.$invalid) {
           /*Ajax Call*/
          this.spinner = true;
          let build = this.$store.getters.getBuildingToEdit;
          this.form.IdBuilding = build.Id;

          let promise = this.validateToken();  
          promise.then(() => {

            axios.post(this.url, {request: "addUserForBuiding", form: this.form }, { headers: {'Content-Type': 'application/json'}})
            .then(()  => {
              this.spinner = false;
              this.resetField();
              this.$emit('changePage', 'BuildingList');
            })
            .catch(()  => {
              this.spinner = false;
              this.error = this.$t('info.errorgeneric');
              this.disabled = false;
            });

          });

        }
    },  
    resetField: function () {
      this.$v.$reset();         
      this.form.user = [];
    },
    setNextPage(page) {
          this.$emit('changePage', page);
    }
  }
}
</script>
